<template>
    <div class="bg-grey vh-100">

        <!-- HEADER -->
        <div class="header-top bg-white">
            <div class="header-top--inner w-limit d-flex justify-content-between align-items-center">
                <div class="header-top--left">
                    <div class="header-item">
                        <img src="../../../assets/icons/back-blue.svg" alt="a" @click="back">
                    </div>
                </div>
                <div class="header-top--middle f-cont f-16 f-bold">{{label}}</div>
                <div class="header-top--right">
                    <div class="header-item"></div>
                </div>
            </div>
        </div>

        <!-- CONTENT -->
        <div class="content-wrapper main-page has-bottom-menu">

            <div class=" m-t-16 w-limit">
                <iframe :src="iframe.src" type="application/pdf" width="100%"
                        height="650" frameborder="0" style="position:relative;" ref="frame"
                        v-show="iframe.loaded">
                </iframe>
            </div>


        </div>

    </div>

</template>

<script>
    export default {
        name: "MesinIbos",
        props:['setidoutlet'],

        data() {
            return {
                label:"List Mesin",
                iframe: {
                    src: "",
                    // src: 'https://bos.smartlink.id/profil?smart_token='+localStorage.getItem('token'), //DIV HERE #EDITOR
                    //src: 'http://local.bos.smartlink.id/profil',///profil?smart_token='+localStorage.getItem('token'), //DIV HERE #EDITOR
                    loaded: false
                }
            }
        },
        methods: {
            back(){
                this.$emit('isdetail')
            },

            load: function (idoutlet) {
                this.iframe.src=this.iframeSrc()+
                    // src: "https://bos.smartlink.id/"+
                    // src: "https://localhost/"+
                    // src:"http://local.bos.smartlink.id/"+
                    "outlet/snap-mesin-v2/"+this.setidoutlet+
                    '?smart_token='+
                    localStorage.getItem('token');
                this.iframe.loaded = true;
            },
            dashboard() {
                this.$router.push('/dashboard')
            },
            karyawan() {
                this.$router.push('/karyawan')
            },

            outlet() {
                this.$router.push('/addoutlet')
            },

            menu() {
                this.$router.push('/detailakunowner')
            },

            toggleMenu() {
                $("#nav-bottom").toggleClass("is-open");
            },


        }

    }

    // alert($(".nav-bottom--inner").outerHeight())

</script>